export const WHATSAPP_REGISTRATION_USER_TYPES = [
  { type: 0, label: "Participantes" },
  { type: 1, label: "Usuários gestores" },
  { type: 2, label: "Expositores" },
];

// Participants register through `fields`; managers and exhibitors through
// `fieldsUsers`. Only the compositions of the user types enabled for automatic
// WhatsApp need the phone field (mirrors registrationPhoneForms on the server).
export function getWhatsAppRegistrationForms(register) {
  const enabled = WHATSAPP_REGISTRATION_USER_TYPES.map(({ type }) => type)
    .filter((type) => register?.templates?.[String(type)]?.enabled !== false);
  return [
    ...(enabled.includes(0) ? ["fields"] : []),
    ...(enabled.some((type) => type !== 0) ? ["fieldsUsers"] : []),
  ];
}

const MISSING_FORM_ERRORS = {
  fields: "Para enviar a participantes, adicione o campo de WhatsApp também ao formulário dos participantes ou desmarque o envio para participantes.",
  fieldsUsers: "Para enviar a usuários gestores ou expositores, adicione o campo de WhatsApp também ao formulário dos usuários gestores ou desmarque o envio para esses tipos.",
};

export function getWhatsAppRegistrationField(fields = [], fieldsUsers = [], register = undefined) {
  const forms = { fields: fields || [], fieldsUsers: fieldsUsers || [] };
  const marked = [...forms.fields, ...forms.fieldsUsers].filter((field) => field?.whatsapp === true);
  const ids = [...new Set(marked.map((field) => String(field.inputID || "")))];
  if (!marked.length) return { field: null, missingForm: null, error: "Defina um campo de telefone para envio de mensagens de WhatsApp na composição do formulário." };
  if (ids.length !== 1 || !ids[0]) return { field: null, missingForm: null, error: "Apenas um campo pode ser definido para envio de mensagens de WhatsApp." };
  const requiredForms = getWhatsAppRegistrationForms(register);
  const used = requiredForms.flatMap((form) => forms[form]
    .filter((field) => field?.whatsapp === true && String(field.inputID) === ids[0]));
  if (used.some((field) => field.type !== "input" || field.validation !== "telefone" || field.required !== true
    || field.hideFieldOnRegister === true || field.dependencies?.length > 0)) {
    return { field: null, missingForm: null, error: "O campo de WhatsApp deve ser um telefone obrigatório, visível e sem condições de exibição." };
  }
  const missingForm = requiredForms.find((form) => !forms[form].some((field) => String(field.inputID) === ids[0] && field.whatsapp === true));
  if (missingForm) return { field: null, missingForm, source: marked[0], error: MISSING_FORM_ERRORS[missingForm] };
  return { field: used[0] || marked[0], missingForm: null, error: "" };
}

// Copy of the phone field for another composition: same inputID, so one
// phone_field_input_id keeps working for every user type.
export const copyWhatsAppRegistrationField = (field, form) => ({
  ...field,
  whatsapp: true,
  required: true,
  hideFieldOnRegister: false,
  dependencies: [],
  ...(form === "fieldsUsers" ? { rfigtag: false } : {}),
});

export const isRegistrationWhatsAppTemplate = (template, type) => (
  template?.purpose === "event_update"
  && (template.target_user_type == null || Number(template.target_user_type) === Number(type))
  && template.status === "approved" && template.provider_status === "approved"
  && template.sendable !== false && template.is_available !== false && template.is_supported !== false
  && template.archived !== true && template.configuration_status === "ready"
  && !JSON.stringify(template.components || {}).includes("rsvp_link")
);

const BUILT_IN = new Set(["nome", "evento", "event_name", "email", "user_id", "user_access_code", "qrcode_download_url", "qrcode_with_user_access_code_url"]);
export function getRegistrationCustomVariables(template) {
  const text = [template?.components?.header?.text, template?.components?.body?.text].filter(Boolean).join(" ");
  return [...new Set([...text.matchAll(/\{\{\s*([a-zA-Z][a-zA-Z0-9_]*)\s*\}\}/g)].map((match) => match[1]))].filter((name) => !BUILT_IN.has(name));
}

export const getWhatsAppRegistrationError = (code) => ({
  WHATSAPP_REGISTRATION_MIGRATION_REQUIRED: "A atualização do banco para envio automático de WhatsApp precisa ser aplicada.",
  WHATSAPP_REGISTRATION_SENDER_REQUIRED: "Selecione o número R1 ativo para enviar o WhatsApp após cadastro.",
  WHATSAPP_REGISTRATION_TEMPLATE_REQUIRED: "Habilite ao menos um tipo e escolha seu modelo de WhatsApp.",
  WHATSAPP_REGISTRATION_TEMPLATE_UNAVAILABLE: "Um modelo de WhatsApp selecionado está indisponível ou não atende ao tipo de usuário. Escolha outro modelo aprovado.",
  WHATSAPP_REGISTRATION_FIELD_DUPLICATE: "Apenas um campo de telefone pode ser definido para envio de WhatsApp.",
  WHATSAPP_REGISTRATION_FIELD_INVALID: "O campo de WhatsApp deve ser um telefone obrigatório, visível e sem condições de exibição.",
  WHATSAPP_REGISTRATION_FIELD_NOT_SHARED: "O campo de WhatsApp precisa estar no formulário de cada tipo de usuário com envio automático habilitado.",
  WHATSAPP_TEMPLATE_BINDINGS_INVALID: "Escolha um campo do formulário para cada variável personalizada do modelo de WhatsApp.",
}[code] || "Não foi possível salvar a configuração de WhatsApp. Revise os modelos e o remetente selecionados.");
